import * as React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  DialogContentText
} from "@mui/material";
import { connect } from "react-redux";
import { platformGhostButtonSx, platformPrimaryButtonSx } from "./tickitPlatformTheme";

const dialogButtonSx = {
  ...platformGhostButtonSx,
  borderWidth: 1.5,
  width: { xs: "100%", sm: "auto" },
};

const dialogConfirmSx = {
  ...platformPrimaryButtonSx,
  width: { xs: "100%", sm: "auto" },
};

function AlertDialog({ open, handleAccept, handleClose, title, content }) {

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="sm"
      className="platform-dialog"
      sx={{
        "& .MuiDialog-paper": {
          width: { xs: "95vw", sm: "100%" },
          m: { xs: 1, sm: 2 },
          bgcolor: "var(--platform-surface)",
          color: "var(--platform-text)",
          border: "1px solid var(--platform-border)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: { xs: "1.1rem", sm: "1.25rem" },
          color: "var(--platform-text)",
        }}
        id="alert-dialog-title"
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ color: "var(--platform-text-2)" }}
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ flexDirection: { xs: "column", sm: "row" }, gap: 1, p: { xs: 2, sm: 1 } }}>
        <Button sx={dialogButtonSx} onClick={handleClose}>Cancel</Button>
        <Button sx={dialogConfirmSx} onClick={handleAccept}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);
